import { render } from "./LogoutView.vue?vue&type=template&id=61c156be"
import script from "./LogoutView.vue?vue&type=script&lang=js"
export * from "./LogoutView.vue?vue&type=script&lang=js"

import "./LogoutView.vue?vue&type=style&index=0&id=61c156be&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__